"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var results_1 = require("../../../results");

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var PATTERN_WITH_PREFIX = new RegExp("(?:within|in|for)\\s*" + "(?:(?:about|around|roughly|approximately|just)\\s*(?:~\\s*)?)?(".concat(constants_1.TIME_UNITS_PATTERN, ")(?=\\W|$)"), "i");
var PATTERN_WITHOUT_PREFIX = new RegExp("(?:(?:about|around|roughly|approximately|just)\\s*(?:~\\s*)?)?(".concat(constants_1.TIME_UNITS_PATTERN, ")(?=\\W|$)"), "i");

var ENTimeUnitWithinFormatParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(ENTimeUnitWithinFormatParser, _AbstractParserWithWo);

  var _super = _createSuper(ENTimeUnitWithinFormatParser);

  function ENTimeUnitWithinFormatParser() {
    _classCallCheck(this, ENTimeUnitWithinFormatParser);

    return _super.apply(this, arguments);
  }

  _createClass(ENTimeUnitWithinFormatParser, [{
    key: "innerPattern",
    value: function innerPattern(context) {
      return context.option.forwardDate ? PATTERN_WITHOUT_PREFIX : PATTERN_WITH_PREFIX;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var timeUnits = constants_1.parseTimeUnits(match[1]);
      return results_1.ParsingComponents.createRelativeFromRefInstant(context.refDate, timeUnits);
    }
  }]);

  return ENTimeUnitWithinFormatParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = ENTimeUnitWithinFormatParser;